<template>
  <div class="ma-2">
    <v-data-table
      v-model="selecionados" 
      item-key="id_reg"
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_mvf" label="Código" placeholder="" :items="codigos" item-text="lb_mvf" item-value="cc_mvf"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.dt_mvf_i_formatada" v-mask="mascaraData" label="Data início" placeholder="" @blur="pesquisa.dt_mvf_i = parseDate(pesquisa.dt_mvf_i_formatada)"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.dt_mvf_f_formatada" v-mask="mascaraData" label="Data fim" placeholder="" @blur="pesquisa.dt_mvf_f = parseDate(pesquisa.dt_mvf_f_formatada)"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-checkbox v-model="pesquisa.bl_sin_man" label="Não sincronizados" value="false"></v-checkbox>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">
                    pesquisar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.cc_fil="{ item }">
            {{ item.cc_fil }}
        </template>
        <template v-slot:item.cc_pdv="{ item }">
            {{ item.cc_pdv }}
        </template>
        <template v-slot:item.cc_mvf="{ item }">
            {{ getDescricaoDoCodigo(item.cc_mvf) }}
        </template>
        <template v-slot:item.vl_mvf="{ item }">
            {{ moeda(item.vl_mvf) }}
        </template>
        <template v-slot:item.dt_mvf="{ item }">
             {{ getDataMovimento(item) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn small depressed fab v-on="on" :color="`${item.bl_sin_man ? 'primary' : '#E8F5E9'}`" @click="tratarSincronia(item)">
                  <v-icon>mdi-sync-circle</v-icon>
                </v-btn>
            </template>
            <span>{{ `${item.bl_sin_man ? 'Desmarcar sincronizado' : 'Marcar como sincronizado'}` }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
  </div>
</template>
<script>
  import lodash from 'lodash'
  import { moeda } from '../../utils.js'
  export default {
    name: 'MovimentoFinanceiro',
    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 70 },
          { text: 'PDV', value: 'cc_pdv', sortable:false, width: 70 },
          { text: 'Codigo', value: 'cc_mvf', sortable:false, width:150},
          { text: 'Valor', value: 'vl_mvf', sortable:false, width:120, align: 'right'},
          { text: 'Data', value: 'dt_mvf', sortable:false},
          { text: '', value: 'action', sortable:false, width: 160, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          cc_mvf: undefined,
          dt_mvf_i: undefined,
          dt_mvf_i_formatada: undefined,
          dt_mvf_f: undefined,
          dt_mvf_f_formatada: undefined,
          st_mvf: undefined,
          bl_sin_man: undefined,
        },
        mascaraData: '##/##/####',

        st_mvf_arr: [{label: 'Pendentes', value:'PD'}, {label: 'Faturados', value:'X0'}],
        selecionados:[],

        filiais: [],
        codigos:[
          {
            cc_mvf: 'SUP',
            lb_mvf: 'Suprimento'
          },
          {
            cc_mvf: 'DES',
            lb_mvf: 'Despesa'
          },
          {
            cc_mvf: 'SGR',
            lb_mvf: 'Sangria'
          },
        ],

        /** atributos da visualização do item */
        dialog: false,
        itemSelecionado: {},
        idModal: 1

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },

    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

    },

    created(){
      this.$vuetify.goTo(0)
    },

    computed: {

      itensTratados(){
        return this.itens.map(x => ({ ...x, isSelectable: x.st_ped === 'PD' }));
      }

    },

    methods: {

      getDescricaoDoCodigo(obj) {
        return this.codigos.filter(e => e.cc_mvf === obj)[0].lb_mvf
      },

      pesquisar() { 
        this.selecionados = []
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (date == null) return null;
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      getDataMovimento(item) { 
        let dataArr = item.dt_mvf.split('-')
        return `${dataArr[2]}/${dataArr[1]}/${dataArr[0]}`
      },

      ver(item) {
        this.idModal = Math.random(1000)
        this.itemSelecionado = item
        this.dialog = true
      },

      tratarSincronia(item) {
        this.$store.dispatch(item.bl_sin_man ? 'anularRecebimentoMovimentoFinanceiro' : 'marcarComoRecebidoMovimentoFinanceiro', item).then(() => {
          item.bl_sin_man = !item.bl_sin_man
        }).catch(err => {
          console.log(err)
        })
      },

      moeda(valor){
        return moeda(valor)
      },

      deletar(obj) {
        if (confirm('Deseja realmente deletar este registro?')) {
          this.$store.dispatch('deletarPedido', obj.id_reg).then(() => {
            var removeIndex = this.itens.map(function(item) { return item.id_reg; }).indexOf(obj.id_reg);
            this.itens.splice(removeIndex, 1);
          }).catch(err => {
            console.log(err)
          })
        } 
      },

      deletarSelecionados(){ console.log(this.selecionados.length); console.log(this.selecionados)
        if(this.selecionados.length > 0){
          if (confirm('Deseja realmente deletar os registros selecionados?')) {
            this.selecionados.forEach( e => {
              if (e.st_ped === 'PD') {
                this.$store.dispatch('deletarPedido', e.id_reg).then(() => {
                  var removeIndex = this.itens.map(function(item) { return item.id_reg; }).indexOf(e.id_reg);
                  this.itens.splice(removeIndex, 1);
                }).catch(() => {})
              }
            })
            this.selecionados = []
          }
        }
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaMovimentoFinanceiro', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>